import { config } from '@/config.ts';

type BrandBaseLanguageConfig = Record<string, string>;

export const brandBaseLanguageMap: BrandBaseLanguageConfig = {
	default: 'ru',
	nomad: 'ru',
	ngu3: 'uk',
	com2: 'uk',
	blitz: 'tr',
	rockets: 'uk',
	rockets_vip: 'uk',
	sk2: 'uk',
	'1king': 'tr'
};

export const getBrandBaseLanguage = (): string => {
	const brand = config.BRAND || 'default';
	return brandBaseLanguageMap[brand] || brandBaseLanguageMap.default;
};
